/**
 * ZALT Store Locator
 *
 * Hardcoded retail locations with Leaflet.js map.
 * Search by city/state/zip, sort by distance from user.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Store data — add new stores here                                    */
  /* Each store needs: name, address, city, state, zip, lat, lng         */
  /* ------------------------------------------------------------------ */

  var storesJson = document.querySelector('[data-stores-json]');
  var STORES = storesJson ? JSON.parse(storesJson.textContent) : [];

  /* ------------------------------------------------------------------ */
  /* DOM refs                                                            */
  /* ------------------------------------------------------------------ */

  var listEl     = document.querySelector('[data-sl-list]');
  var searchEl   = document.querySelector('[data-sl-search]');
  var searchBtn  = document.querySelector('[data-sl-search-btn]');
  var locateBtn  = document.querySelector('[data-sl-locate]');
  var countEl    = document.querySelector('[data-sl-count]');
  var mapContainer = document.getElementById('store-map');

  if (!listEl || !mapContainer) return;

  /* ------------------------------------------------------------------ */
  /* Map setup                                                           */
  /* ------------------------------------------------------------------ */

  // Default center: center of US
  var map = L.map('store-map', {
    scrollWheelZoom: true,
    zoomControl: true
  }).setView([39.5, -98.5], 4);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors',
    maxZoom: 19
  }).addTo(map);

  // Custom marker icon
  var storeIcon = L.divIcon({
    className: 'sl-marker',
    html: '<div style="width:28px;height:28px;background:#CC5951;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.25);"><div style="width:10px;height:10px;background:#fff;border-radius:50%;transform:rotate(45deg);"></div></div>',
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -28]
  });

  var markers = [];
  var userLat = null;
  var userLng = null;

  /* ------------------------------------------------------------------ */
  /* Haversine distance (miles)                                          */
  /* ------------------------------------------------------------------ */

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 3959; // Earth radius in miles
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* ------------------------------------------------------------------ */
  /* Render store list                                                   */
  /* ------------------------------------------------------------------ */

  function renderList(stores) {
    if (stores.length === 0) {
      listEl.innerHTML = '<div class="sl-empty">No stores found. Try a different search.</div>';
      countEl.textContent = '';
      return;
    }

    countEl.textContent = '— ' + stores.length + (stores.length === 1 ? ' store' : ' stores');

    var html = '';
    stores.forEach(function (store, i) {
      var dist = store._distance != null ? store._distance.toFixed(1) + ' mi' : '';
      var fullAddr = store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip;
      var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(fullAddr);

      html += '<div class="sl-store" data-sl-idx="' + i + '">';
      html += '  <div class="sl-store__icon">';
      html += '    <div class="sl-store__pin"><div class="sl-store__pin-inner"></div></div>';
      if (dist) html += '    <div class="sl-store__dist">' + dist + '</div>';
      html += '  </div>';
      html += '  <div class="sl-store__info">';
      html += '    <div class="sl-store__name">' + store.name + '</div>';
      html += '    <div class="sl-store__address">' + store.address + '<br>' + store.city + ', ' + store.state + ' ' + store.zip + '</div>';
      html += '    <a class="sl-store__directions" href="' + directionsUrl + '" target="_blank" rel="noopener">Directions</a>';
      html += '  </div>';
      html += '</div>';
    });
    listEl.innerHTML = html;

    // Bind clicks
    listEl.querySelectorAll('[data-sl-idx]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.sl-store__directions')) return; // let link work
        var idx = parseInt(el.getAttribute('data-sl-idx'), 10);
        focusStore(stores[idx], idx);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Render map markers                                                  */
  /* ------------------------------------------------------------------ */

  function renderMarkers(stores) {
    // Clear existing
    markers.forEach(function (m) { map.removeLayer(m); });
    markers = [];

    if (stores.length === 0) return;

    var bounds = L.latLngBounds();

    stores.forEach(function (store) {
      var fullAddr = store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip;
      var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(fullAddr);

      var popup = '<div class="sl-popup__name">' + store.name + '</div>' +
                  '<div class="sl-popup__address">' + store.address + '<br>' + store.city + ', ' + store.state + ' ' + store.zip + '</div>' +
                  '<a class="sl-popup__link" href="' + directionsUrl + '" target="_blank" rel="noopener">Get Directions →</a>';

      var marker = L.marker([store.lat, store.lng], { icon: storeIcon })
        .bindPopup(popup)
        .addTo(map);

      markers.push(marker);
      bounds.extend([store.lat, store.lng]);
    });

    if (userLat != null) {
      bounds.extend([userLat, userLng]);
    }

    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
  }

  /* ------------------------------------------------------------------ */
  /* Focus on a store                                                    */
  /* ------------------------------------------------------------------ */

  function focusStore(store, idx) {
    map.setView([store.lat, store.lng], 15);
    if (markers[idx]) markers[idx].openPopup();

    // Highlight in list
    listEl.querySelectorAll('.sl-store').forEach(function (el, i) {
      el.classList.toggle('is-active', i === idx);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Sort stores by distance from a point                                */
  /* ------------------------------------------------------------------ */

  function sortByDistance(stores, lat, lng) {
    stores.forEach(function (s) {
      s._distance = haversine(lat, lng, s.lat, s.lng);
    });
    stores.sort(function (a, b) { return a._distance - b._distance; });
    return stores;
  }

  /* ------------------------------------------------------------------ */
  /* Search — filters by city, state, or zip; or geocodes via Nominatim  */
  /* ------------------------------------------------------------------ */

  function doSearch(query) {
    if (!query.trim()) {
      // Reset
      var all = STORES.slice();
      if (userLat != null) {
        sortByDistance(all, userLat, userLng);
      } else {
        all.forEach(function (s) { s._distance = null; });
      }
      renderList(all);
      renderMarkers(all);
      return;
    }

    var q = query.trim().toLowerCase();

    // First try local filter
    var matches = STORES.filter(function (s) {
      return s.city.toLowerCase().indexOf(q) !== -1 ||
             s.state.toLowerCase().indexOf(q) !== -1 ||
             s.zip.indexOf(q) !== -1 ||
             s.name.toLowerCase().indexOf(q) !== -1;
    });

    if (matches.length > 0) {
      // Use centroid of matches for distance if no user location
      var centLat = matches.reduce(function (sum, s) { return sum + s.lat; }, 0) / matches.length;
      var centLng = matches.reduce(function (sum, s) { return sum + s.lng; }, 0) / matches.length;
      var refLat = userLat != null ? userLat : centLat;
      var refLng = userLng != null ? userLng : centLng;
      sortByDistance(matches, refLat, refLng);
      renderList(matches);
      renderMarkers(matches);
      return;
    }

    // Fallback: geocode the query via Nominatim and find nearest stores
    fetch('https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&limit=1&q=' + encodeURIComponent(query))
      .then(function (r) { return r.json(); })
      .then(function (results) {
        if (results.length === 0) {
          renderList([]);
          renderMarkers([]);
          return;
        }
        var lat = parseFloat(results[0].lat);
        var lng = parseFloat(results[0].lon);
        var sorted = sortByDistance(STORES.slice(), lat, lng);
        // Show stores within 100 miles, or top 10
        var nearby = sorted.filter(function (s) { return s._distance <= 100; });
        if (nearby.length === 0) nearby = sorted.slice(0, 10);
        renderList(nearby);
        renderMarkers(nearby);
      })
      .catch(function () {
        renderList([]);
        renderMarkers([]);
      });
  }

  /* ------------------------------------------------------------------ */
  /* Geolocation                                                         */
  /* ------------------------------------------------------------------ */

  function locateUser() {
    if (!navigator.geolocation) return;

    locateBtn.textContent = 'Locating...';
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        userLat = pos.coords.latitude;
        userLng = pos.coords.longitude;
        locateBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg> Location found';

        var sorted = sortByDistance(STORES.slice(), userLat, userLng);
        renderList(sorted);
        renderMarkers(sorted);
      },
      function () {
        locateBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg> Location unavailable';
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* Event listeners                                                     */
  /* ------------------------------------------------------------------ */

  searchBtn.addEventListener('click', function () { doSearch(searchEl.value); });
  searchEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') doSearch(searchEl.value);
  });
  locateBtn.addEventListener('click', locateUser);

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */

  var allStores = STORES.slice();
  allStores.forEach(function (s) { s._distance = null; });
  renderList(allStores);
  renderMarkers(allStores);

})();
